namespace $ { export class $mol_app_todomvc extends $mol_scroller {

	/// title @ \todos
	title() {
		return this.localizedText( "title" )
	}

	/// titler $mol_viewer 
	/// 	heightMinimal 142 
	/// 	childs / < title
	@ $mol_mem()
	titler( next? : any , prev? : any ) {
		return new $mol_viewer().setup( obj => { 
			obj.heightMinimal = () => 142
			obj.childs = () => [].concat( this.title() )
		} )
	}

	/// allCompleterEnabled false
	allCompleterEnabled() {
		return false
	}

	/// allCompleted false
	@ $mol_mem()
	allCompleted( next? : any , prev? : any ) {
		return ( next !== void 0 ) ? next : false
	}

	/// allCompleter $mol_checker 
	/// 	enabled < allCompleterEnabled 
	/// 	checked > allCompleted 
	/// 	childs / \❯
	@ $mol_mem()
	allCompleter( next? : any , prev? : any ) {
		return new $mol_checker().setup( obj => { 
			obj.enabled = () => this.allCompleterEnabled()
			obj.checked = ( next? , prev? ) => this.allCompleted( next , prev )
			obj.childs = () => [].concat( "❯" )
		} )
	}

	/// taskNewTitle \
	@ $mol_mem()
	taskNewTitle( next? : any , prev? : any ) {
		return ( next !== void 0 ) ? next : ""
	}

	/// eventAdd null
	@ $mol_mem()
	eventAdd( next? : any , prev? : any ) {
		return ( next !== void 0 ) ? next : <any> null
	}

	/// adder $mol_app_todomvc_adder 
	/// 	value > taskNewTitle 
	/// 	eventDone > eventAdd
	@ $mol_mem()
	adder( next? : any , prev? : any ) {
		return new $mol_app_todomvc_adder().setup( obj => { 
			obj.value = ( next? , prev? ) => this.taskNewTitle( next , prev )
			obj.eventDone = ( next? , prev? ) => this.eventAdd( next , prev )
		} )
	}

	/// headerContent / 
	/// 	< allCompleter 
	/// 	< adder
	headerContent() {
		return [].concat( this.allCompleter() , this.adder() )
	}

	/// header $mol_viewer 
	/// 	heightMinimal 64 
	/// 	childs < headerContent
	@ $mol_mem()
	header( next? : any , prev? : any ) {
		return new $mol_viewer().setup( obj => { 
			obj.heightMinimal = () => 64
			obj.childs = () => this.headerContent()
		} )
	}

	/// taskRows /
	taskRows() {
		return [] as any[]
	}

	/// lister $mol_lister rows < taskRows
	@ $mol_mem()
	lister( next? : any , prev? : any ) {
		return new $mol_lister().setup( obj => { 
			obj.rows = () => this.taskRows()
		} )
	}

	/// pendingMessage @ \0 items left
	pendingMessage() {
		return this.localizedText( "pendingMessage" )
	}

	/// pendinger $mol_viewer childs / < pendingMessage
	@ $mol_mem()
	pendinger( next? : any , prev? : any ) {
		return new $mol_viewer().setup( obj => { 
			obj.childs = () => [].concat( this.pendingMessage() )
		} )
	}

	/// filterAllLabel @ \All
	filterAllLabel() {
		return this.localizedText( "filterAllLabel" )
	}

	/// filterAll $mol_linker 
	/// 	childs / < filterAllLabel 
	/// 	arg * completed null
	@ $mol_mem()
	filterAll( next? : any , prev? : any ) {
		return new $mol_linker().setup( obj => { 
			obj.childs = () => [].concat( this.filterAllLabel() )
			obj.arg = () => ({
			"completed" : ()=> <any> <any> null ,
		})
		} )
	}

	/// filterActiveLabel @ \Active
	filterActiveLabel() {
		return this.localizedText( "filterActiveLabel" )
	}

	/// filterActive $mol_linker 
	/// 	childs / < filterActiveLabel 
	/// 	arg * completed false
	@ $mol_mem()
	filterActive( next? : any , prev? : any ) {
		return new $mol_linker().setup( obj => { 
			obj.childs = () => [].concat( this.filterActiveLabel() )
			obj.arg = () => ({
			"completed" : ()=> <any> false ,
		})
		} )
	}

	/// filterCompletedLabel @ \Completed
	filterCompletedLabel() {
		return this.localizedText( "filterCompletedLabel" )
	}

	/// filterCompleted $mol_linker 
	/// 	childs / < filterCompletedLabel 
	/// 	arg * completed true
	@ $mol_mem()
	filterCompleted( next? : any , prev? : any ) {
		return new $mol_linker().setup( obj => { 
			obj.childs = () => [].concat( this.filterCompletedLabel() )
			obj.arg = () => ({
			"completed" : ()=> <any> true ,
		})
		} )
	}

	/// filterOptions / 
	/// 	< filterAll 
	/// 	< filterActive 
	/// 	< filterCompleted
	filterOptions() {
		return [].concat( this.filterAll() , this.filterActive() , this.filterCompleted() )
	}

	/// filter $mol_barer childs < filterOptions
	@ $mol_mem()
	filter( next? : any , prev? : any ) {
		return new $mol_barer().setup( obj => { 
			obj.childs = () => this.filterOptions()
		} )
	}

	/// sanitizerEnabled true
	sanitizerEnabled() {
		return true
	}

	/// eventSanitize null
	eventSanitize() {
		return <any> null
	}

	/// sanitizerLabel @ \Clear completed
	sanitizerLabel() {
		return this.localizedText( "sanitizerLabel" )
	}

	/// sanitizer $mol_clicker_minor 
	/// 	enabled < sanitizerEnabled 
	/// 	eventClick < eventSanitize 
	/// 	childs / < sanitizerLabel
	@ $mol_mem()
	sanitizer( next? : any , prev? : any ) {
		return new $mol_clicker_minor().setup( obj => { 
			obj.enabled = () => this.sanitizerEnabled()
			obj.eventClick = () => this.eventSanitize()
			obj.childs = () => [].concat( this.sanitizerLabel() )
		} )
	}

	/// footerContent / 
	/// 	< pendinger 
	/// 	< filter 
	/// 	< sanitizer
	footerContent() {
		return [].concat( this.pendinger() , this.filter() , this.sanitizer() )
	}

	/// footer $mol_viewer childs < footerContent
	@ $mol_mem()
	footer( next? : any , prev? : any ) {
		return new $mol_viewer().setup( obj => { 
			obj.childs = () => this.footerContent()
		} )
	}

	/// panels / 
	/// 	< header 
	/// 	< lister 
	/// 	< footer
	panels() {
		return [].concat( this.header() , this.lister() , this.footer() )
	}

	/// paneler $mol_lister rows < panels
	@ $mol_mem()
	paneler( next? : any , prev? : any ) {
		return new $mol_lister().setup( obj => { 
			obj.rows = () => this.panels()
		} )
	}

	/// pager $mol_lister childs / 
	/// 	< titler 
	/// 	< paneler
	@ $mol_mem()
	pager( next? : any , prev? : any ) {
		return new $mol_lister().setup( obj => { 
			obj.childs = () => [].concat( this.titler() , this.paneler() )
		} )
	}

	/// childs / < pager
	childs() {
		return [].concat( this.pager() )
	}

	/// taskCompleted# false
	@ $mol_mem_key()
	taskCompleted( key : any , next? : any , prev? : any ) {
		return ( next !== void 0 ) ? next : false
	}

	/// taskTitle# \
	@ $mol_mem_key()
	taskTitle( key : any , next? : any , prev? : any ) {
		return ( next !== void 0 ) ? next : ""
	}

	/// eventTaskDrop# null
	@ $mol_mem_key()
	eventTaskDrop( key : any , next? : any , prev? : any ) {
		return ( next !== void 0 ) ? next : <any> null
	}

	/// taskRow# $mol_app_todomvc_taskRow 
	/// 	completed > taskCompleted# 
	/// 	title > taskTitle# 
	/// 	eventDrop > eventTaskDrop#
	@ $mol_mem_key()
	taskRow( key : any , next? : any , prev? : any ) {
		return new $mol_app_todomvc_taskRow().setup( obj => { 
			obj.completed = ( next? , prev? ) => this.taskCompleted( key , next , prev )
			obj.title = ( next? , prev? ) => this.taskTitle( key , next , prev )
			obj.eventDrop = ( next? , prev? ) => this.eventTaskDrop( key , next , prev )
		} )
	}

} }

namespace $ { export class $mol_app_todomvc_adder extends $mol_stringer {

	/// hint @ \What needs to be done?
	hint() {
		return this.localizedText( "hint" )
	}

	/// eventPress null
	@ $mol_mem()
	eventPress( next? : any , prev? : any ) {
		return ( next !== void 0 ) ? next : <any> null
	}

	/// event * keyup > eventPress
	event() {
		return $mol_merge_dict( super.event() , {
			"keyup" : ( next? : any , prev? : any )=> <any> this.eventPress( next , prev ) ,
		} )
	}

	/// eventDone null
	@ $mol_mem()
	eventDone( next? : any , prev? : any ) {
		return ( next !== void 0 ) ? next : <any> null
	}

} }

namespace $ { export class $mol_app_todomvc_taskRow extends $mol_viewer {

	/// heightMinimal 64
	heightMinimal() {
		return 64
	}

	/// completed false
	@ $mol_mem()
	completed( next? : any , prev? : any ) {
		return ( next !== void 0 ) ? next : false
	}

	/// completer $mol_checker 
	/// 	checked > completed 
	/// 	childs /
	@ $mol_mem()
	completer( next? : any , prev? : any ) {
		return new $mol_checker().setup( obj => { 
			obj.checked = ( next? , prev? ) => this.completed( next , prev )
			obj.childs = () => [] as any[]
		} )
	}

	/// titleHint @ \Task title
	titleHint() {
		return this.localizedText( "titleHint" )
	}

	/// title \
	@ $mol_mem()
	title( next? : any , prev? : any ) {
		return ( next !== void 0 ) ? next : ""
	}

	/// titler $mol_stringer 
	/// 	hint < titleHint 
	/// 	value > title
	@ $mol_mem()
	titler( next? : any , prev? : any ) {
		return new $mol_stringer().setup( obj => { 
			obj.hint = () => this.titleHint()
			obj.value = ( next? , prev? ) => this.title( next , prev )
		} )
	}

	/// eventDrop null
	@ $mol_mem()
	eventDrop( next? : any , prev? : any ) {
		return ( next !== void 0 ) ? next : <any> null
	}

	/// dropper $mol_clicker 
	/// 	childs / \✖
	/// 	eventClick > eventDrop
	@ $mol_mem()
	dropper( next? : any , prev? : any ) {
		return new $mol_clicker().setup( obj => { 
			obj.childs = () => [].concat( "✖" )
			obj.eventClick = ( next? , prev? ) => this.eventDrop( next , prev )
		} )
	}

	/// childs / 
	/// 	< completer 
	/// 	< titler 
	/// 	< dropper
	childs() {
		return [].concat( this.completer() , this.titler() , this.dropper() )
	}

	/// attr * mol_app_todomvc_taskRow_completed < completed
	attr() {
		return $mol_merge_dict( super.attr() , {
			"mol_app_todomvc_taskRow_completed" : ()=> <any> this.completed() ,
		} )
	}

} }

